export default __webpack_public_path__ + "static/media/120-raindrops.dc0afa7e.jpeg";